import Chart from "chart.js/auto";
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import useDimension from "../../../costomHook/useDimention";
import { customWidth } from "../../../UIConstants";

export const LineGraph = (props) => {
  const { graph1X, graph1Y, lineGraphData } = props;
  console.log(lineGraphData);
  const [detailLabel, setDetailLabel] = useState("");
  const dimention = useDimension();

  useEffect(() => {
    graph1Y?.map((item) => {
      if (item?.isSelected) {
        setDetailLabel(item?.label);
      }
    });
  }, [graph1Y]);

  // console.log(lineGraphData);
  // console.log(graph1X);

  const [value, setValue] = useState({});
  useEffect(() => {
    const xAxisActiveObj = graph1X.filter((obj) => {
      return obj.isSelected;
    })[0];

    const yAxisActiveObj = graph1Y.filter((obj) => {
      return obj.isSelected;
    })[0];

    getValues(xAxisActiveObj, yAxisActiveObj);
  }, [graph1X, graph1Y, lineGraphData]);

  const getValues = (xAxisActiveObj, yAxisActiveObj) => {
    let activeObjKey = `${xAxisActiveObj.id}_${yAxisActiveObj.id}`;

    let keysObj = {
      year_registration: "yearwiseRegistartionsCount",
      month_registration: "monthwiseRegistartionsCount",
      day_registration: "daywiseRegistartionsCount",

      day_goldMember: "",
      month_goldMember: "",
      year_goldMember: "",

      year_auction: "yearwiseExecutedAuctionsCount",
      month_auction: "monthwiseExecutedAuctionsCount",
      day_auction: "daywiseExecutedAuctionsCount",

      year_auctionAmount: "yearwiseExecutedAuctionsAmount",
      month_auctionAmount: "monthwiseExecutedAuctionsAmount",
      day_auctionAmount: "daywiseExecutedAuctionsAmount",

      day_lottery: "daywiseExecutedLotteriesCount",
      month_lottery: "monthwiseExecutedLotteriesCount",
      year_lottery: "yearwiseExecutedLotteriesCount",

      year_lotteryAmount: "yearwiseExecutedLotteriesAmount",
      month_lotteryAmount: "monthwiseExecutedLotteriesAmount",
      day_lotteryAmount: "daywiseExecutedLotteriesAmount",

      day_visitors: "daywiseVisitorsCount",
      month_visitors: "monthwiseVisitorsCount",
      year_visitors: "yearwiseVisitorsCount",

      year_users: "",
      month_users: "",
      day_users: "",
    };

    let xAxisKey = `${xAxisActiveObj.id}`;

    let xAxisLabels = [];
    let yAxisValues = [];

    let valuesArray = lineGraphData[keysObj[activeObjKey]];

    if (valuesArray) {
      for (let valueObj of valuesArray) {
        xAxisLabels.push(valueObj[xAxisKey]);
        yAxisValues.push(valueObj.count);
      }

      setValue({
        label: xAxisLabels,
        data: yAxisValues,
      });
    } else {
      setValue({
        label: [],
        data: [],
      });
    }
  };

  const data = {
    labels: value.label,
    datasets: [
      {
        label: `# of ${detailLabel}`,
        data: value.data,
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div style={{ height: "340px", width: "390px" }}>
      <Line
        data={data}
        height="340px"
        width={dimention.width <= customWidth ? "350px" : "390px"}
        options={{
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: `${detailLabel} Details`,
            },
            legend: {
              display: true,
              position: "bottom",
            },
          },
        }}
      />
    </div>
  );
};
